import { useMutation } from '@apollo/client';
import { RemoveProductMutation, RemoveProductMutationVariables } from '_graphql/mutation/__generated__/graphql';
// import {
//   RemoveProduct,
//   RemoveProductVariables,
// } from '_graphql/mutation/__generated__/RemoveProduct';
import { REMOVE_PRODUCT } from '_graphql/mutation/products';

export const useDeleteProduct = (variables?: RemoveProductMutationVariables) => {
  const [productDeletion, { ...rest }] = useMutation<
    RemoveProductMutation,
    RemoveProductMutationVariables
  >(REMOVE_PRODUCT, {
    variables,
    refetchQueries: ['GetProducts'],
  });
  return {
    ...rest,
    productDeletion,
  };
};
